import aboutUsVideo from "@assets/videos/about-us-video.mp4";
import { Portal } from "@design-system/components/Portal";
import { aboutUsVideoPortal } from "../portal-atoms.ts";

export function AboutUsVideoPortal() {
  return (
    <Portal portal={aboutUsVideoPortal} classes={{ content: "p-0 bg-transparent" }}>
      <div className="flex flex-col gap-8">
        <video src={aboutUsVideo} autoPlay controls className="rounded-2xl" />
      </div>
    </Portal>
  );
}
